import { Component, inject, signal, OnInit } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { SvgIconsService } from '../../core/services/svg-icons.service';
import { NavbarComponent } from '../navbar/navbar.component';
import { MainNavbarComponent } from '../main-navbar/main-navbar.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-main-layout',
  imports: [
    RouterModule,
    MatIconModule,
    CommonModule,
    NavbarComponent,
    MainNavbarComponent
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit {
  protected iconService = inject(SvgIconsService);
  protected router = inject(Router);

  isClientRoute = signal(false);
  isComparisonRoute = signal(false);
  isMafRoute = signal(false);

  ngOnInit(): void {
    this.checkRoute();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkRoute();
      });
  }

  private checkRoute(): void {
    const currentUrl = this.router.url;
    this.isClientRoute.set(currentUrl.includes('/preference-form'));
    this.isComparisonRoute.set(currentUrl.includes('/comparison'));
    this.isMafRoute.set(currentUrl.includes('/maf') && !this.isReviewMafOnlineRoute(currentUrl));
  }

  private isReviewMafOnlineRoute(url: string): boolean {
    return url.includes('/review-queue/application-review/') && url.includes('/maf-online');
  }
}
